import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

type StatusCardProps = {
  status: string;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 80px);
  padding: 25px 45px;

  @media (max-width: 768px) {
    padding: 25px 20px 240px;
    height: 100%;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 1;
  margin-bottom: 15px;
`;

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 463px 355px 300px;
  grid-template-rows: auto;
  column-gap: 15px;
  row-gap: 15px;
  grid-template-areas:
    "bill spending ultragazEnergia"
    "bills ctos ultragazEnergia";

  @media (max-width: 768px) {
    grid-template-columns: 100%;
    grid-template-areas:
      "bill"
      "spending"
      "bills"
      "ctos"
      "ultragazEnergia";
  }
`;

type ShowTourProps = {
  showTour: boolean;
};

export const ContainerWrap = styled.div`
  position: relative;
`;

export const ContentBill = styled.div<ShowTourProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  grid-area: bill;
  border-left: 8px solid ${({ theme }) => theme.colors.blue};
  background-color: #fff;
  border-radius: 8px;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const ContentBannerUltragazEnergia = styled.div`
  display: flex;
  align-items: flex-start;
  grid-area: ultragazEnergia;
`;

export const ContentBannerPromotions = styled.div<ShowTourProps>`
  grid-area: ultragazEnergia;
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const ContentBannerAntiFraude = styled.div`
  display: flex;
  align-items: flex-start;
  grid-area: antiFraude;
`;

export const LinkBannerUltragazEnergia = styled(Link)`
  width: 100%;
`;

export const LinkAntiFraude = styled.a`
  width: 100%;
`;

export const BannerUltragazEnergia = styled.img`
  width: 100%;
  border-radius: 8px;
`;

export const HeaderCard = styled.div`
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 25px 10px 17px;

  @media (max-width: 768px) {
    padding: 10px 20px;
  }
`;

export const TitleCard = styled.span`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 16px;
  line-height: 1;
`;

export const ExtraCard = styled.div`
  display: flex;
  align-items: center;

  & span {
    color: ${({ theme }) => theme.colors.gray};
    font-size: 12px;
    line-height: 1;
  }
`;

export const StatusCard = styled.div<StatusCardProps>`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  margin-right: 5px;

  background-color: ${({ status, theme }) => {
    switch (status) {
      case "VENCIDO":
        return theme.colors.red;
      case "PAGO":
        return theme.colors.lightGreen;
      case "A_VENCER":
        return theme.colors.darkYellow;
      default:
        return "#000";
    }
  }};
`;

export const BodyBill = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  padding: 0 25px 0 17px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const MonthYearBill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 4px;
  background-color: #efefef;

  & span:first-of-type {
    color: ${({ theme }) => theme.colors.blue};
    font-family: "Mangueira bold";
    font-size: 16px;
    line-height: 1;
    margin-bottom: 5px;
    text-transform: capitalize;
  }

  & span:last-of-type {
    font-size: 14px;
    line-height: 1;
  }

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const DueDateBill = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  & span:first-of-type {
    color: ${({ theme }) => theme.colors.blue};
    font-family: "Mangueira bold";
    font-size: 12px;
  }

  & span:last-of-type {
    font-size: 16px;
  }
`;

export const ValueBill = styled.span`
  font-size: 30px;
  line-height: 1;
  font-family: "Mangueira bold";
  color: ${({ theme }) => theme.colors.blue};

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const FooterBill = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px 10px 17px;

  @media (max-width: 768px) {
    padding: 0 20px 10px;
    flex-direction: column;
    gap: 5px;
  }
`;

export const ButtonCopy = styled.button`
  border: none;
  background: transparent;
  outline: none;
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  color: ${({ theme }) => theme.colors.gray};

  & svg {
    margin-left: 5px;
    font-size: 16px;
  }
`;

export const ButtonBills = styled(Link)`
  padding: 10px 10px;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }

  & svg {
    margin-left: 5px;
    font-size: 16px;
  }
`;

export const ContentSpending = styled.div<ShowTourProps>`
  grid-area: spending;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  background-color: #fff;
  border-radius: 8px;

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const BodySpending = styled.div`
  display: flex;
  width: 100%;
  padding: 0 25px;
`;

export const FooterSpeding = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 25px 10px;
`;
